export default __webpack_public_path__ + "static/media/se.2ca8780d.svg";